import { Component } from "@angular/core";
import { OAuthService } from "app/services/o-auth";
import { Router } from "@angular/router";
import { ApiService } from "app/services/api";
import { AngularFireDatabase } from "angularfire2/database";

@Component({
    templateUrl: './insights-manager.component.html'
})
export class InsightsManagerComponent {
  public user: any
  constructor(private oAuthService: OAuthService, public router: Router, public apiService: ApiService, private fireDatabase: AngularFireDatabase) {

    this.user = this.oAuthService.getClub()


  }


}
